import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import IconButton from 'material-ui/IconButton'
import ContentCreate from 'material-ui/svg-icons/content/create'
import Chip from 'material-ui/Chip'
import { stringify } from 'query-string'
import Avatar from 'material-ui/Avatar'
import AlertWarning from 'material-ui/svg-icons/alert/warning'

const DocStatus = ({ basePath = '', record = {} }) => {
	const { id, fields } = record
	if ( fields.has_doc_def ) {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<IconButton
					containerElement={<Link to={{
						pathname: `/accounts/${id}`,
						search: stringify({ tab: 3 }),
					}} />}
					style={{ overflow: 'inherit' }} >
					<ContentCreate color="#0277bd" />
				</IconButton>
				<Chip backgroundColor="#e91e63" labelColor="#fff" containerElement={<Link to={{
						pathname: `/accounts/${id}`,
						search: stringify({ tab: 3 }),
					}} />} >
					<Avatar backgroundColor="#c2185b" color="#fff" icon={<AlertWarning />} />
					Doc Def
				</Chip>
			</div>
		)
	}
	if ( fields.has_pending_docs ) {
		return (
			<div style={{ display: 'flex', alignItems: 'center' }}>
				<IconButton
					containerElement={<Link to={{
						pathname: `/accounts/${id}`,
						search: stringify({ tab: 2 }),
					}} />}
					style={{ overflow: 'inherit' }} >
					<ContentCreate color="#0277bd" />
				</IconButton>
				<Chip backgroundColor="#ffc107" labelColor="#fff" containerElement={<Link to={{
			            pathname: `/accounts/${id}`,
			            search: stringify({ tab: 2 }),
			        }} />} >
					<Avatar backgroundColor="#ffa000" color="#fff" icon={<AlertWarning />} />
					Pending Docs
				</Chip>
			</div>
		)
	}
	return null
}

DocStatus.propTypes = {
    basePath: PropTypes.string,
    record: PropTypes.object,
};

DocStatus.defaultProps = {
    style: { padding: 0 },
};

export default DocStatus;



// WEBPACK FOOTER //
// ./src/DCAccount/DocStatus.js